<template>
    <div>
        <v-navigation-drawer
            v-model="fileUploadDialog"
            temporary
            absolute
            right
            width="46%"
            overlay-opacity="0"
            class="drawer-shadow">
            <v-card tile class="drawer-content pb-12">
                <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
                    <div class="d-inline">
                         Upload Client Files
                    </div>
                    <div class="d-inline">
                        <v-btn 
                            icon
                            outlined
                            color="info"
                            elevation="1"
                            @click="closeClientUploads">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text class="pt-3">
                    <UploadClientFiles 
                        :projectData="projectDetails"
                        :moduleKey="projectDetails.modinfo.module_key"
                        :projectId="projectDetails.project_id"
                        :userId="projectDetails.user_id"
                        :isDeliverable="false"
                        :isIndependent="true"
                        @triggerUserFeedback="triggerUserFeedback"
                        @closeClientUploads="closeClientUploads"
                        @refreshDocs="refreshDocs"
                    />
                </v-card-text>
            </v-card>
        </v-navigation-drawer>

        <div class="my-6 mb-12 align-center">
            <div class="d-flex d-block align-center mb-2">
                <div class="sansation label_medium info--text d-inline">Client Uploaded Files</div>
                <v-btn
                    v-if="projectDetails.module_key == 'buyer'"
                    icon
                    x-small
                    class="ml-3 mt-n1 primary--text text--darken-1 d-inline"
                    :style="refresh_docs ? 'border:none' : 'border:1px solid #3b9ba7'"
                    :loading="refresh_docs"
                    @click="refreshDocs()">
                    <v-icon v-if="!refresh_docs"
                        small
                        class="primary--text text--darken-1">
                        mdi-autorenew
                    </v-icon>
                </v-btn>
                <div class="d-inline ml-4 info--text">{{ (projectDetails.revs.length + projectDetails.docs.length) }} file{{ (projectDetails.revs.length + projectDetails.docs.length) == 1 ? '':'s' }}</div>
                <v-spacer></v-spacer>
                <div class="d-inline">
                    <v-btn
                        small
                        class="ml-6 d-inline menu_bg_primary primary--text text--darken-1"
                        elevation=0
                        @click="fileUploadDialog = true">
                        Upload Client Files
                        <v-icon small color="primary" class="ml-2" right>mdi-cloud-upload</v-icon>
                    </v-btn>
                </div>
            </div>

            <v-data-table
                v-if="projectDetails.revs.length"
                :headers="rev_headers"
                :items="projectDetails.revs"
                :options.sync="options"
                :loading="refresh_docs"
                disable-pagination
                hide-default-footer
                class="revisions_bgcolor"
                :class="projectDetails.docs.length ? 'mb-9' : ''">
                
                <template v-slot:header="{ headers }">
                    <thead>
                        <tr>
                            <td v-for="column in headers" :key="column.value">
                                {{column.text}}
                            </td>
                        </tr>
                    </thead>
                </template>

                <template v-slot:body="{ items }">
                    <tbody name="list" is="transition-group">
                        <tr v-for="item in items" :key="item.key" class="item-row avenir_book">
                            <td class="text-start"><a :href="item.url" class="clean_link" target="_blank">{{ item.file_name }}</a></td>
                            <td class="text-start text-capitalize"></td>
                            <td class="text-start text-capitalize"></td>
                            <td class="text-start text-capitalize">{{ item.user_name }}</td>
                            <td class="text-start" width="12%">{{ formatDate(item.file_upload_date) }}</td>
                            <td class="text-end" width="2%">
                                <v-icon
                                    small
                                    @click="deleteFile(item)">
                                    mdi-delete
                                </v-icon>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-data-table>

            <v-data-table
                v-if="projectDetails.docs.length"
                :headers="doc_headers"
                :items="projectDetails.docs"
                :options.sync="options"
                :loading="refresh_docs"
                disable-pagination
                hide-default-footer>
                
                <template v-slot:header="{ headers }">
                    <thead>
                        <tr>
                            <td v-for="column in headers" :key="column.value">
                                {{column.text}}
                            </td>
                        </tr>
                    </thead>
                </template>

                <template v-slot:body="{ items }">
                    <tbody name="list" is="transition-group">
                        <tr v-for="item in items" :key="item.key" class="item-row">
                            <td class="text-start"><a :href="item.url" target="_blank">{{ item.file_name }}</a></td>
                            <td class="text-start text-capitalize">{{ item.section }}</td>
                            <td class="text-start text-capitalize">{{ item.question }}</td>
                            <td class="text-start text-capitalize">{{ item.user_name }}</td>
                            <td class="text-start" width="12%">{{ formatDate(item.file_upload_date) }}</td>
                            <td class="text-end" width="2%">
                                <v-icon
                                    small
                                    @click="deleteFile(item)">
                                    mdi-delete
                                </v-icon>
                            </td>
                        </tr>
                    </tbody>
                </template>
            </v-data-table>
        </div>
    </div>
</template>


<script>  
    import axios from "axios";
    import Cookie from 'js-cookie';
    import appUrls from '../helpers/environment';

    import UploadClientFiles from './UploadClientFiles'

    export default {
        name: 'ProjectFiles',

        components: {
            UploadClientFiles
        },

        props: {
            projectDetails: Object,
            refresh_docs: Boolean,
            formatThisDate: Function,
            triggerUserFeedback: Function,
            pullProjectDocs: Function
        },

        data () {
            return {
                fileUploadDialog: false,
                doc_headers: [
                    {   text: 'File Name',     
                        value: 'file_name',    
                        align: 'start',  
                        sortable: true 
                    },
                    {   text: 'Section',     
                        value: 'section',
                        align: 'left',    
                        sortable: true 
                    },
                    {   text: 'Question/Category',     
                        value: 'question',
                        align: 'left',    
                        sortable: true 
                    },
                    {   text: 'Uploaded By',     
                        value: 'user_name',
                        align: 'left',    
                        sortable: true 
                    },
                    {   text: 'Uploaded',     
                        value: 'file_upload_date',
                        align: 'left',    
                        sortable: true 
                    },
                    {   text: ' ',
                        value: '',
                        align: 'right',
                        sortable: false
                    }
                ],
                rev_headers: [
                    {   text: 'File Name',     
                        value: 'file_name',    
                        align: 'start',  
                        sortable: true 
                    },
                    {   text: '',     
                        value: '',
                        align: 'left',    
                        sortable: true 
                    },
                    {   text: 'Revisions',     
                        value: '',
                        align: 'left',    
                        sortable: true 
                    },
                    {   text: 'Uploaded By',     
                        value: 'user_name',
                        align: 'left',    
                        sortable: true 
                    },
                    {   text: 'Uploaded',     
                        value: 'file_upload_date',
                        align: 'left',    
                        sortable: true 
                    },
                    {   text: ' ',
                        value: '',
                        align: 'right',
                        sortable: false
                    }
                ],
                options: {
                    sortBy: ['file_upload_date'],
                    sortDesc: [true],
                    // Initialize other options as needed
                    itemsPerPage: -1, // Show all items
                    multiSort: true
                },
            }
        },

        watch: {
            refresh_docs (val) {
                this.refresh_docs = val;
            }
        },
        
        methods: {
            closeClientUploads: function () {
                this.fileUploadDialog = false
            },

            refreshDocs: function () {
                this.$emit('pullProjectDocs', this.projectDetails, 'client' )
            },
            
            formatDate: function ( date_to_format ) {
                const options = {
                    month: '2-digit', 
                    day: '2-digit', 
                    year: 'numeric'
                }

                const formatted_date = this.formatThisDate(date_to_format, options);
                return formatted_date ? formatted_date : 'N/A';
            },

            deleteFile: async function (item) {
                try {
                    // console.log(item)
                    const confirm_rs = confirm('Are you sure you want to delete this file from this project?');

                    if ( confirm_rs ) { 
                        const delete_client_file = await axios.put(`${appUrls.api}/api/rm_uploaded_file`, {
                            headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
                            file_data: item
                        });

                        if ( delete_client_file.data.outcome ) {
                            this.refreshDocs()
                        }
                    }
                } catch ( err ) {
                    console.log( err )
                }
            },
        },

        mounted () {
            // console.log(this.projectDetails)
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .bg_pewter {
        background-color: #E9EAEC;
    }
    .menu_bg_primary {
        background-color: #eef7f8 !important;
    }
    .icon-size {
        width: 3rem;
    }
    .icon-size-small {
        width: 2.25rem;
    }
    .icon-size-header {
        width: 2.5rem;
    }
    .icon-center {
        margin: 0 auto;
    }
    .revisions_bgcolor {
        background-color: #eef7f8; /* #ececed */
    }
    .drawer-shadow {
        position: fixed !important;
        top: 0 !important;
        right: 0 !important;
        height: 100vh !important;
        z-index: 2000;
        box-shadow: -6px 0 12px rgba(0, 0, 0, 0.15);
    }
    .drawer-content {
        height: 100%; /* Full height of the drawer */
        overflow-y: auto; /* Allow vertical scrolling */
        background-color: whitesmoke !important;
    }
    /* Hide scrollbar but allow scrolling */
    .drawer-content::-webkit-scrollbar {
        display: none; /* For Chrome, Safari, and Edge */
    }
    .drawer-content {
        -ms-overflow-style: none; /* For Internet Explorer and Edge */
        scrollbar-width: none; /* For Firefox */
    }
</style>


// WEBPACK FOOTER //
// src/components/ProjectFiles.vue